"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPatronsList = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Returns a list of all patrons.
 *
 * ### Filter options
 *
 * - `tier` - filter by tier of the patron.
 *
 * ### Sort options
 *
 * - `tier` - sort by tier of the patron.
 *
 * ## Usage
 *
 * ```ts
 * const patronsAll: Featured[] = await sdk.getPatronsList({ });
 * const patronsTier4: Featured[] =
 * 	await sdk.getPatronsList({ filter: { tier: PatronTier.TIER4 }});
 * ```
 *
 * @param params.filter - Filter to apply to returned patrons list.
 * @param params.sort - Fields to sort patrons list by.
 * @param params.limit - How many patrons will get returned.
 */
const getPatronsList = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { filter, sort, limit } = params;
    const url = `${BASE_URL}/patrons/list`;
    const featuredResponse = yield axios_1.default.post(url, { filter, sort, limit }, { validateStatus: () => true });
    const { status, data } = featuredResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.getPatronsList = getPatronsList;
